import * as luxon from 'luxon';

/* eslint-disable max-len */
import { createFeature, createReducer, on } from '@ngrx/store';

import { OrdAllocateActions } from './ord-allocate.actions';

export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: any;
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: [],
    receivedTime: null,
};

export default createFeature({
  name: 'ordAllocate',
  reducer: createReducer(
    initialState,
    on(OrdAllocateActions.error, (state: State, { error }): State => ({
        ...state,
        error,
        loaded: false,
        loading: false
    })),
    on(OrdAllocateActions.reset, (state: State): State => ({
        ...state,
        data: null,
        error: null,
        loaded: false,
        loading: false
    })),
    on(OrdAllocateActions.received, (state: State, { result }): State => ({
        ...state,
        data: result,
        error: null,
        loaded: true,
        loading: false,
        receivedTime: luxon.DateTime.now().toISO(),
    })),
    on(OrdAllocateActions.load, (state: State, { }): State => ({
        ...state,
        loaded: false,
        loading: true
    }))
  )}
);